const SliderIndicator = ({ isStart, isEnd }: { isStart: boolean; isEnd: boolean }) => {
  return (
    <div className='flex justify-center items-center gap-4 pt-8'>
      <div className="flex items-center space-x-2">
        <div className={`${isStart ? "w-10 bg-[#99A0AF]" : "w-2 bg-gray-300"} h-2 rounded-full`}></div>
        <div className={`${!isStart && !isEnd ? "w-10 bg-[#99A0AF]" : "w-2 bg-gray-300"} h-2 rounded-full`}></div>
        <div className={`${isEnd ? "w-10 bg-[#99A0AF]" : "w-2 bg-gray-300"} h-2 rounded-full`}></div>
      </div>
    </div>
  )
}

export default SliderIndicator